import { render, staticRenderFns } from "./documents-history.vue?vue&type=template&id=57961d4a"
import script from "./documents-history.vue?vue&type=script&lang=js"
export * from "./documents-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports